import { memo } from "react";
import { ISchedulesTableProps } from "./models";
import MySchedulesTable from "./MySchedulesTable";
import LinkAccessTable from "./LinkAccessTable";

const SchedulesTable: React.FC<ISchedulesTableProps> = ({
  schedules,
  checkInRule,
  isHistoric,
}) => {
  return (
    <>
      {!schedules.isLinkAccess && (
        <MySchedulesTable data={schedules.data} checkInRule={checkInRule} />
      )}

      {schedules.isLinkAccess && (
        <LinkAccessTable data={schedules.data} isHistoric={isHistoric} />
      )}
    </>
  );
};

export default memo(SchedulesTable);
